import { apiClient } from './apiClient';
import { Month } from '../types/month';

export async function fetchMonth(token: string, year: number, month: number) {
  return apiClient<{ data: Month }>(`/months/${year}/${month}`, {
    method: 'GET',
    token,
  });
}

export async function computeMonth(token: string, year: number, month: number, force = false) {
  const body = force ? { force: true } : {};

  return apiClient<{ data: Month }>(`/months/${year}/${month}/compute`, {
    method: 'POST',
    token,
    body: JSON.stringify(body),
  });
}

export async function listMonths(token: string) {
  return apiClient<{ data: Month[] }>(`/months`, {
    method: 'GET',
    token,
  });
}

export type MonthOwnerBalance = {
  previous_month_balance: number;
  current_month_opening_balance?: number;
  current_month_earnings: number;
  current_month_expenses: number;
  current_month_profit_allocation: number;
  current_month_owner_draws?: number;
  current_month_balance: number;
};

export async function fetchMonthOwnerBalances(token: string, year: number, month: number) {
  return apiClient<{ data: Record<string, MonthOwnerBalance> }>(`/months/${year}/${month}/owner-balances`, {
    method: 'GET',
    token,
  });
}

